import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingTagsKeys } from './query-key-factory';

export type DeleteMarketingTagRequest = { MarketingTagId: number };

export type DeleteMarketingTagResult = {
  success: boolean;
};

export function useDeleteMarketingTagMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: DeleteMarketingTagRequest) =>
      postData<DeleteMarketingTagRequest, DeleteMarketingTagResult>({
        endpoint: 'api/marketing-campaign/delete-marketing-tag',
        payload,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: marketingTagsKeys.all });
    },
  });
}
